import React from "react";
import IcomoonReact from "icomoon-react"; //{ iconList }
const iconSet = require("../../Assets/Fonts/selection.json");

const Icon = ({ ...props }) => <IcomoonReact iconSet={iconSet} {...props} />;

export default Icon;